import { render, staticRenderFns } from "./price-list.vue?vue&type=template&id=dc27c8aa&scoped=true&"
import script from "./price-list.vue?vue&type=script&lang=js&"
export * from "./price-list.vue?vue&type=script&lang=js&"
import style0 from "./price-list.vue?vue&type=style&index=0&id=dc27c8aa&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc27c8aa",
  null
  
)

export default component.exports